var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.6 666.7",
    style: {
      enableBackground: "new 0 0 666.6 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.9,666.2h200c166.7,0,233.3-66.7,233.3-233.3v-200C667.3,66.2,600.6-0.5,433.9-0.5h-200 C67.3-0.5,0.6,66.2,0.6,232.8v200C0.6,599.5,67.3,666.2,233.9,666.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.6,416.5V249.3c0-18.5,10.3-28.9,27.9-28.9s27.7,10.4,27.7,28.9v60.1h87v-60.1 c0-18.5,10.1-28.9,27.7-28.9s27.7,10.4,27.7,28.9v167.3c0,18.5-10.1,28.9-27.7,28.9s-27.7-10.4-27.7-28.9v-62.4h-87v62.4 c0,18.5-10.1,28.9-27.7,28.9S190.6,435,190.6,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M421.7,416.5V249.3c0-18.5,10.3-28.9,27.9-28.9s27.7,10.4,27.7,28.9v167.3c0,18.5-10.1,28.9-27.7,28.9 S421.7,435,421.7,416.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiButton);
export default __webpack_public_path__ + "static/media/hi_button.96ce97377ec1957363b929b9da6fedbd.svg";
export { ForwardRef as ReactComponent };